<template>
  <scoped>
    <TrademarkToolbar
      v-model:value="trademarkInput"
      @update="update()"
      @reset="reset()"
    />
    <TrademarkList
      v-if="trademarkResponse"
      v-model:selectedIndex="selectedIndex"
      :items="trademarkResponse.records"
      @select="select()"
    />
    <Paginator
      v-if="trademarkResponse"
      v-model:currentPage="trademarkInput.plot.page"
      :itemTotal="trademarkResponse.recordsTotal"
      :pageItems="trademarkInput.plot.items"
      @update="update()"
    />
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import TrademarkList from "@/components/lists/trademark.vue"
  import TrademarkToolbar from "@/components/toolbars/trademark.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Trademark,
    TrademarkInput,
    TrademarkResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Trademark as TrademarkClient} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {TrademarkSelector as Storage} from "@/storage/trademark_selector"
  import ErrorModal from "@/components/modals/error.vue"

  const value = defineModel("value", {
    default: null,
    required: false,
    type: Object as PropType<Trademark>
  })

  const emits = defineEmits([
    "select",
  ])

  const error = ref<Error>(null)
  const trademarkClient = new TrademarkClient()
  const trademarkResponse = ref<TrademarkResponse>(null)
  const trademarkInput = ref<TrademarkInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeTrademarkInput(trademarkInput.value)
    read()
  }

  async function select() {
    const selectedTrademark = trademarkResponse.value.records[selectedIndex.value]
    value.value = selectedTrademark
    Storage.writeSelectedTrademarkID(selectedTrademark.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteTrademarkInput()
    Storage.deleteSelectedTrademarkID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      const storedTrademarkInput = Storage.readTrademarkInput()
      trademarkInput.value = structuredClone(storedTrademarkInput)
      trademarkResponse.value = await trademarkClient.selector(storedTrademarkInput)
      if (!trademarkResponse.value || !trademarkResponse.value.records) {
        return
      }
      const storedSelectedTrademarkID = Storage.readSelectedTrademarkID()
      for (const [index, trademark] of trademarkResponse.value.records.entries()) {
        if (trademark.id == storedSelectedTrademarkID) {
          selectedIndex.value = index
          value.value = trademark
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }
</script>
